
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 548 548"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M274 0C122.7 0 0 122.7 0 274s122.7 274 274 274 274-122.7 274-274S425.3 0 274 0zm56.9 200.2h-20.7c-7.8 0-13.1 1.7-15.9 5.2-2.3 2.9-3.5 7.4-3.5 13.8v27.2h36.7l-5.2 39.3h-31.5v98.8h-40.5v-98.8h-33.2v-39.3h33.2v-31.1c0-16.4 4.6-29.1 13.8-38.2 9.2-9.1 21.4-13.6 36.7-13.6 12.4 0 22.4.6 30.2 1.7l-.1 35z","fill":"#47474c"}})])
          )
        }
      }
    